module.exports = __webpack_public_path__ + "img/artboard7.70aa541e.png";